// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__13-sX","footer__contact":"Footer_footer__contact__3VEz0","footer__message":"Footer_footer__message__2RHRA"};